import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { UsersActions, UserSearchParams, UsersSelectors, UsersState } from '@store';

@Injectable({ providedIn: 'root' })
export class UsersStore {
  constructor(public store: Store) {}

  getUsers(): Observable<UsersState> {
    return this.store.select(UsersSelectors.getUsers());
  }

  listCompanyUsersSearchResult(companyNumber: string): void {
    this.store.dispatch(
      UsersActions.listCompanyUsersSearchResult({
        companyNumber,
      })
    );
  }

  listUsersSearchResult(params: UserSearchParams): void {
    this.store.dispatch(
      UsersActions.listUsersSearchResult({
        searchParams: {
          loginId: this.transformForWildcardSearch(params.loginId),
          firstName: this.transformForWildcardSearch(params.firstName),
          familyName: this.transformForWildcardSearch(params.familyName),
          city: this.transformForWildcardSearch(params.city),
          street: this.transformForWildcardSearch(params.street),
          postalCode: this.transformForWildcardSearch(params.postalCode),
          limit: params.limit,
          offset: params.offset,
        },
      })
    );
  }

  fetchMoreUsers(searchParams: any, limit: number, offset: number): void {
    this.store.dispatch(
      UsersActions.listUsersSearchFetchMore({
        searchParams: {
          loginId: searchParams.loginId,
          firstName: searchParams.firstName,
          familyName: searchParams.familyName,
          city: searchParams.city,
          street: searchParams.street,
          postalCode: searchParams.postalCode,
          limit,
          offset,
        },
      })
    );
  }

  private transformForWildcardSearch(text: string): string {
    return `*${text}*`;
  }
}
